import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahCabang, getAllCabang, getAllClient } from "stores";
import { getAllAnggotaCabang } from "stores";
import { getAllSupervisor } from "stores";
import { getAllAreaManager } from "stores";
import { ubahPenempatanSupervisor } from "stores";
import { ubahPenempatanAreaManager } from "stores";

function ListCabang() {
  const dispatch = useDispatch();
  // const [singleSelect, setSingleSelect] = React.useState("");
  const cabang = useSelector((state) => state.cabangReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const storeSpv = useSelector((state) => state.supervisorReducer);
  const storeAM = useSelector((state) => state.areaManagerReducer);
  const auth = useSelector((state) => state.authReducer);
  const [modalCabang, setModalCabang] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalPenempatanSupervisor, setModalPenempatanSupervisor] =
    React.useState(false);
  const [modalPenempatanAM, setModalPenempatanAM] = React.useState(false);
  const [namaCabang, setNamaCabang] = React.useState("");
  const [idCabang, setIdCabang] = React.useState("");
  const [pilihClient, setPilihClient] = React.useState(null);
  const [filterClient, setFilterClient] = React.useState(null);
  const [alamat, setAlamat] = React.useState("");
  const [listCabang, setListCabang] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClientCbg, setIdClientCbg] = React.useState("");
  const [detailCabang, setDetailCabang] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [listSpv, setListSpv] = React.useState([]);
  const [listAM, setListAM] = React.useState([]);
  const [pilihSpv, setPilihSpv] = React.useState(null);
  const [pilihAM, setPilihAM] = React.useState(null);
  const [idSsBaru, setidSsBaru] = React.useState(null);
  const [idAmBaru, setidAmBaru] = React.useState(null);

  const itemsPerPage = 10;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (selectedOption) => {
    setFilterClient(selectedOption);
    getAllCabang(dispatch, { idClient: selectedOption.value });
  };

  const submitCabang = () => {
    tambahCabang({
      cabang_id: idCabang,
      namaCabang: namaCabang,
      alamat: alamat,
      idClient: idClientCbg,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllCabang(dispatch, { idClient: "" });
        } else if (response.data.status === 403) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const submitUbahPenempatanSS = () => {
    if (pilihSpv === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Supervisor tidak boleh kosong",
      });
    } else {
      ubahPenempatanSupervisor({
        idCabang: idCabang,
        idSsLama: cabang.listAllAnggotaCabang.listSupervisor[0].idUser,
        idSsBaru: idSsBaru,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihSpv(null);
          setidSsBaru(null);
          getAllCabang(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitUbahPenempatanAM = () => {
    // console.log("idCabang", idCabang, "idSsBaru", idAmBaru);
    // console.log(cabang.listAllAnggotaCabang.listAreaManager[0].idUser);
    if (pilihAM === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Area Manager tidak boleh kosong",
      });
    } else {
      ubahPenempatanAreaManager({
        idCabang: idCabang,
        idAmLama: cabang.listAllAnggotaCabang.listAreaManager[0].idUser,
        idAmBaru: idAmBaru,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihAM(null);
          setidAmBaru(null);
          getAllCabang(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleModalClose = () => {
    setModalCabang(false);
    setPilihClient("");
    setIdClientCbg("");
    setIdCabang("");
    setAlamat("");
    setNamaCabang("");
    setPilihSpv("");
    setPilihAM("");
    setModalPenempatanSupervisor(false);
    setModalPenempatanAM(false);
  };

  React.useEffect(() => {
    let tmp =
      cabang.listCabang &&
      cabang.listCabang.map((val) => {
        return {
          ...val,
          action: (
            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Cabang</Tooltip>}
              >
                <Button
                  className="shadow-sm"
                  style={{
                    backgroundColor: "#0EA5E9",
                    border: "none",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#0284C7";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#0EA5E9";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                  onClick={() => {
                    setModalDetail(!modalDetail);
                    setDetailCabang(val);
                    getAllAnggotaCabang(dispatch, { idCabang: val._id });
                  }}
                >
                  <i className="fas fa-info-circle"></i>
                </Button>
              </OverlayTrigger>
              {auth.role === "super admin" || auth.role === "admin" ? <>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Ubah Penempatan SS</Tooltip>}
                >
                  <Button
                    className="shadow-sm"
                    style={{
                      backgroundColor: "#10B981",
                      border: "none",
                      borderRadius: "8px",
                      padding: "6px 12px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#059669";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#10B981";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                    onClick={() => {
                      setModalPenempatanSupervisor(!modalPenempatanSupervisor);
                      getAllSupervisor(dispatch, { idClient: "" });
                      setIdCabang(val._id);
                      getAllAnggotaCabang(dispatch, { idCabang: val._id });
                    }}
                  >
                    <i className="fas fa-user-shield"></i>
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Ubah Penempatan AM</Tooltip>}
                >
                  <Button
                    className="shadow-sm"
                    style={{
                      backgroundColor: "#8B5CF6",
                      border: "none",
                      borderRadius: "8px",
                      padding: "6px 12px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#7C3AED";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#8B5CF6";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                    onClick={() => {
                      setModalPenempatanAM(!modalPenempatanAM);
                      getAllAreaManager(dispatch, { idClient: "" });
                      setIdCabang(val._id);
                      getAllAnggotaCabang(dispatch, { idCabang: val._id });
                    }}
                  >
                    <i className="fas fa-map-marked-alt"></i>
                  </Button>
                </OverlayTrigger>
              </> : null}

            </div>
          ),
        };
      });
    setListCabang(tmp);
  }, [cabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeSpv.listSupervisor &&
      storeSpv.listSupervisor.map((val) => {
        tmp.push({
          value: val._id,
          label: val.nama,
        });
      });

    setListSpv(tmp);
  }, [storeSpv.listSupervisor]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeAM.listAreaManager &&
      storeAM.listAreaManager.map((val) => {
        tmp.push({
          value: val._id,
          label: val.nama,
        });
      });

    setListAM(tmp);
  }, [storeAM.listAreaManager]);

  const customStyles = {
    rows: {
      style: {
        height: "60px",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#F8FAFC !important",
          boxShadow: "inset 0 0 0 9999px rgba(0, 0, 0, 0.02)",
          cursor: "pointer",
        },
      },
    },
    headRow: {
      style: {
        minHeight: "56px",
        backgroundColor: "#F1F5F9",
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        borderBottom: "2px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: "700",
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        "&:first-child": {
          borderRight: "1px solid #E2E8F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        "&:first-child": {
          borderRight: "1px solid #E2E8F0",
        },
      },
    },
  };

  const colCabang = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Kode Cabang",
      minWidth: "100px",
      center: true,
      selector: (row) => row.cabang_id,
    },
    {
      name: "Nama Cabang",
      minWidth: "200px",
      center: true,
      selector: (row) => row.namaCabang,
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      selector: (row) => row.client,
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    getAllCabang(dispatch, { idClient: "" });
    getAllClient(dispatch);
    getAllSupervisor(dispatch, { idClient: "" });
    getAllAreaManager(dispatch, { idClient: "" });
  }, []);

  return (
    <>
      <Modal
        size="lg"
        show={modalPenempatanAM}
        // onHide={() => setModalPenempatanSupervisor(!modalPenempatanSupervisor)}
        onHide={() => {
          handleModalClose();
          setModalPenempatanAM(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h4"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Ubah Penempatan Area Manager
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                {/* <Col md="6"> */}
                <Form.Group>
                  <label style={{ color: "black" }}>Pilih Area Manager</label>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="Pilih Area Manager"
                    value={pilihAM}
                    onChange={(value) => {
                      setPilihAM(value);
                      setidAmBaru(value.value);
                      // setIdCabang(value.value);
                    }}
                    options={listAM}
                    placeholder="Pilih Area Manager"
                  />
                </Form.Group>
                {/* </Col> */}
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                onClick={submitUbahPenempatanAM}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      <Modal
        size="lg"
        show={modalPenempatanSupervisor}
        // onHide={() => setModalPenempatanSupervisor(!modalPenempatanSupervisor)}
        onHide={() => {
          handleModalClose();
          setModalPenempatanSupervisor(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h4"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Ubah Penempatan Supervisor
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                {/* <Col md="6"> */}
                <Form.Group>
                  <label style={{ color: "black" }}>Pilih Supervisor</label>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="Pilih Supervisor"
                    value={pilihSpv}
                    onChange={(value) => {
                      setPilihSpv(value);
                      setidSsBaru(value.value);
                    }}
                    options={listSpv}
                    placeholder="Pilih Supervisor"
                  />
                </Form.Group>
                {/* </Col> */}
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                onClick={submitUbahPenempatanSS}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}></Modal.Header>
        <Modal.Body style={{ paddingTop: 0 }}>
          <h4
            style={{
              fontWeight: "800",
              textTransform: "uppercase",
              color: "#2C3E50",
              fontSize: "20px",
              marginBottom: "24px",
              textAlign: "center",
              letterSpacing: "1px"
            }}
          >
            Detail Cabang
          </h4>
          <div style={{ backgroundColor: "#F8FAFC", borderRadius: "16px", padding: "24px", border: "1px solid #E2E8F0" }}>
            {/* Row 1: BPD */}
            <div style={{ display: "flex", alignItems: "center", borderBottom: "1px dashed #CBD5E1", paddingBottom: "16px", marginBottom: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", width: "250px", flexShrink: 0 }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "#E0F2FE", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "16px" }}>
                  <i className="fas fa-university" style={{ color: "#0284C7", fontSize: "16px" }}></i>
                </div>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "#475569" }}>BPD</span>
              </div>
              <div style={{ fontSize: "16px", fontWeight: "700", color: "#1E293B" }}>
                {detailCabang.client}
              </div>
            </div>

            {/* Row 2: Cabang */}
            <div style={{ display: "flex", alignItems: "center", borderBottom: "1px dashed #CBD5E1", paddingBottom: "16px", marginBottom: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", width: "250px", flexShrink: 0 }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "#DCFCE7", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "16px" }}>
                  <i className="fas fa-map-marker-alt" style={{ color: "#16A34A", fontSize: "16px" }}></i>
                </div>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "#475569" }}>Cabang</span>
              </div>
              <div style={{ fontSize: "16px", fontWeight: "700", color: "#1E293B" }}>
                {detailCabang.namaCabang}
              </div>
            </div>

            {/* Row 3: Area Manager */}
            <div style={{ display: "flex", alignItems: "flex-start", borderBottom: "1px dashed #CBD5E1", paddingBottom: "16px", marginBottom: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", width: "250px", flexShrink: 0, marginTop: "4px" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "#FEF3C7", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "16px" }}>
                  <i className="fas fa-user-tie" style={{ color: "#D97706", fontSize: "16px" }}></i>
                </div>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "#475569" }}>Area Manager</span>
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {cabang.listAllAnggotaCabang.listAreaManager && cabang.listAllAnggotaCabang.listAreaManager.length > 0 ? (
                  cabang.listAllAnggotaCabang.listAreaManager.map((val, idx) => (
                    <div key={idx} style={{ display: "flex", alignItems: "center", padding: "8px 16px", borderRadius: "20px", border: "1px solid #E2E8F0", backgroundColor: "#FFFFFF" }}>
                      <i className="fas fa-user-circle" style={{ color: "#64748B", marginRight: "8px", fontSize: "16px" }}></i>
                      <span style={{ fontSize: "14px", fontWeight: "600", color: "#334155" }}>{val.namaAreaManager}</span>
                    </div>
                  ))
                ) : (
                  <div style={{ display: "flex", alignItems: "center", padding: "8px 16px", borderRadius: "20px", border: "1px dashed #CBD5E1", backgroundColor: "#F8FAFC" }}>
                    <span style={{ fontSize: "14px", fontWeight: "500", color: "#94A3B8" }}>Belum Memiliki</span>
                  </div>
                )}
              </div>
            </div>

            {/* Row 4: Supervisor */}
            <div style={{ display: "flex", alignItems: "flex-start", borderBottom: "1px dashed #CBD5E1", paddingBottom: "16px", marginBottom: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", width: "250px", flexShrink: 0, marginTop: "4px" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "#F3E8FF", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "16px" }}>
                  <i className="fas fa-user-shield" style={{ color: "#9333EA", fontSize: "16px" }}></i>
                </div>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "#475569" }}>Supervisor</span>
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {cabang.listAllAnggotaCabang.listSupervisor && cabang.listAllAnggotaCabang.listSupervisor.length > 0 ? (
                  cabang.listAllAnggotaCabang.listSupervisor.map((val, idx) => (
                    <div key={idx} style={{ display: "flex", alignItems: "center", padding: "8px 16px", borderRadius: "20px", border: "1px solid #E2E8F0", backgroundColor: "#FFFFFF" }}>
                      <i className="fas fa-user-circle" style={{ color: "#64748B", marginRight: "8px", fontSize: "16px" }}></i>
                      <span style={{ fontSize: "14px", fontWeight: "600", color: "#334155" }}>{val.namaSupervisor}</span>
                    </div>
                  ))
                ) : (
                  <div style={{ display: "flex", alignItems: "center", padding: "8px 16px", borderRadius: "20px", border: "1px dashed #CBD5E1", backgroundColor: "#F8FAFC" }}>
                    <span style={{ fontSize: "14px", fontWeight: "500", color: "#94A3B8" }}>Belum Memiliki</span>
                  </div>
                )}
              </div>
            </div>

            {/* Row 5: Marketing */}
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div style={{ display: "flex", alignItems: "center", width: "250px", flexShrink: 0, marginTop: "4px" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "#FEE2E2", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "16px" }}>
                  <i className="fas fa-users" style={{ color: "#EF4444", fontSize: "16px" }}></i>
                </div>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "#475569" }}>Marketing</span>
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {cabang.listAllAnggotaCabang.listMarketing && cabang.listAllAnggotaCabang.listMarketing.length > 0 ? (
                  cabang.listAllAnggotaCabang.listMarketing.map((val, idx) => (
                    <div key={idx} style={{ display: "flex", alignItems: "center", padding: "8px 16px", borderRadius: "20px", border: "1px solid #E2E8F0", backgroundColor: "#FFFFFF" }}>
                      <i className="fas fa-user-circle" style={{ color: "#64748B", marginRight: "8px", fontSize: "16px" }}></i>
                      <span style={{ fontSize: "14px", fontWeight: "600", color: "#334155" }}>{val.namaMarketing}</span>
                    </div>
                  ))
                ) : (
                  <div style={{ display: "flex", alignItems: "center", padding: "8px 16px", borderRadius: "20px", border: "1px dashed #CBD5E1", backgroundColor: "#F8FAFC" }}>
                    <span style={{ fontSize: "14px", fontWeight: "500", color: "#94A3B8" }}>Belum Memiliki</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="shadow-sm" style={{ border: "none", borderRadius: "20px" }}>
              <Card.Header style={{ padding: "24px 24px 0" }}>
                <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                  <Col md={4}>
                    <Card.Title
                      as="h3"
                      style={{
                        color: "#2C3E50",
                        fontWeight: "800",
                        textTransform: "uppercase",
                        margin: 0,
                        fontSize: "24px",
                        letterSpacing: "1px"
                      }}
                    >
                      List Cabang
                    </Card.Title>
                  </Col>
                  <Col md={8} style={{ display: "flex", justifyContent: "flex-end" }}>
                    {auth.role === "super admin" || auth.role === "admin" ? (
                      <Button
                        className="shadow-sm"
                        style={{
                          backgroundColor: "#0EA5E9",
                          border: "none",
                          borderRadius: "10px",
                          padding: "10px 20px",
                          fontWeight: "600",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#0284C7";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#0EA5E9";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        onClick={() => setModalCabang(!modalCabang)}
                      >
                        <i className="fas fa-plus mr-2"></i> Tambah Cabang
                      </Button>
                    ) : null}
                  </Col>
                </Row>

                <Row style={{ marginBottom: "15px" }}>
                  {auth.role === "super admin" ? (
                    <Col md={4} className="mb-3">
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="Pilih Client"
                        value={filterClient}
                        onChange={(selectedOption) =>
                          handleFilterChange(selectedOption)
                        }
                        options={[
                          { value: "", label: "All" },
                          ...listClient,
                        ]}
                        placeholder="Pilih Client..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            border: "1px solid #E2E8F0",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.02)",
                            padding: "2px",
                          })
                        }}
                      />
                    </Col>
                  ) : null}
                  <Col md={auth.role === "super admin" ? 8 : 12} className="mb-3">
                    <InputGroup style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.02)", borderRadius: "10px", overflow: "hidden" }}>
                      <InputGroup.Prepend>
                        <InputGroup.Text style={{ backgroundColor: "#FFF", border: "1px solid #E2E8F0", borderRight: "none" }}>
                          <i className="fas fa-search" style={{ color: "#94A3B8" }}></i>
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        style={{
                          padding: "12px 16px",
                          border: "1px solid #E2E8F0",
                          borderLeft: "none",
                          fontSize: "14px",
                          backgroundColor: "#FFF"
                        }}
                        type="text"
                        value={searchText}
                        onChange={handleSearch}
                        placeholder="Cari Kode Cabang / Nama Cabang..."
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </Card.Header>

              <Tab.Content>
                <Card.Body>
                  <DataTable
                    columns={colCabang}
                    data={listCabang.filter(
                      (row) =>
                        row.cabang_id
                          .toLowerCase()
                          .includes(searchText.toLowerCase()) ||
                        row.namaCabang
                          .toLowerCase()
                          .includes(searchText.toLowerCase())
                    )}
                    customStyles={customStyles}
                    pagination
                    paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                    paginationPerPage={itemsPerPage}
                    onChangePage={handlePageChange}
                  />
                </Card.Body>

                <Modal
                  size="lg"
                  show={modalCabang}
                  onHide={() => {
                    handleModalClose();
                    setModalCabang(false);
                  }}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Col md="12" style={{ marginTop: 20 }}>
                    <Card className="stacked-form">
                      <Card.Header>
                        <Card.Title
                          as="h4"
                          style={{ color: "black", fontWeight: "bold" }}
                        >
                          Tambah Cabang Baru
                          <hr></hr>
                        </Card.Title>
                      </Card.Header>
                      <Card.Body>
                        <Form action="#" method="#">
                          <Form.Group>
                            <label style={{ color: "black" }}>Id Cabang</label>
                            <Form.Control
                              onChange={(e) => {
                                setIdCabang(e.target.value);
                              }}
                              placeholder="Nama Cabang"
                              type="text"
                            ></Form.Control>
                            <label style={{ color: "black" }}>
                              Nama Cabang
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setNamaCabang(e.target.value);
                              }}
                              placeholder="Nama Cabang"
                              type="text"
                            ></Form.Control>
                            <label style={{ color: "black" }}>Alamat</label>
                            <Form.Control
                              onChange={(e) => {
                                setAlamat(e.target.value);
                              }}
                              placeholder="Alamat"
                              type="text"
                            ></Form.Control>
                          </Form.Group>
                          {auth.role === "super admin" ? (
                            <Form.Group>
                              <label style={{ color: "black" }}>
                                Pilih Client
                              </label>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="Pilih Client"
                                value={pilihClient}
                                onChange={(value) => {
                                  setPilihClient(value);
                                  setIdClientCbg(value.value);
                                }}
                                options={listClient}
                                placeholder="Pilih Client"
                              />
                            </Form.Group>
                          ) : null}
                        </Form>
                      </Card.Body>
                      <Card.Footer>
                        <Button
                          className="btn-fill"
                          type="submit"
                          variant="info"
                          onClick={submitCabang}
                        >
                          Submit
                        </Button>
                      </Card.Footer>
                    </Card>
                  </Col>
                </Modal>
              </Tab.Content>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* <Card.Title as="h3">List Cabang</Card.Title> */}
    </>
  );
}

export default ListCabang;
